import { Calendar } from "primereact/calendar";
import { ColumnFilterElementTemplateOptions } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import TransactionStatusHelper from "./TransactionStatusHelper";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import React from "react";
import { PaymentStatus } from "../../models/Transactions";
import { AppBadge } from "../../components/ui";
import { EllipsisVertical } from "lucide-react";

export const StatusFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
    return (
        <Dropdown
            value={options.value}
            options={TransactionStatusHelper.Statuses}
            onChange={(e) => options.filterApplyCallback(e.value)}
            placeholder="Select a Status"
            className="p-column-filter"
            showClear
        />
    );
};

export const InputTextFilerTemplate = (options: ColumnFilterElementTemplateOptions, placeholder: string | null = null) => {
    return (
        <InputText
            value={options.value ?? ""}
            onChange={(e) => options.filterApplyCallback(e.target.value)}
            placeholder={placeholder ?? "Enter search text"}
            className="p-column-filter"
        />
    );
};

export const TransactionTypeFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
    return (
        <Dropdown
            value={options.value}
            options={TransactionStatusHelper.TransactionTypes}
            onChange={(e) => options.filterApplyCallback(e.value)}
            placeholder="Select a TRX Type"
            className="p-column-filter"
            showClear
        />
    );
};

export const DateFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
    return (
        <Calendar
            value={options.value}
            onChange={(e) => options.filterApplyCallback(e.value)}
            dateFormat="dd/mm/yy"
            placeholder="dd/mm/yyyy"
            mask="99/99/9999"
        />
    );
};

const badgeVariantMap: Record<string, "success" | "danger" | "warning" | "info" | "primary" | "default"> = {
    success: "success",
    danger: "danger",
    warning: "warning",
    primary: "primary",
    info: "info",
};

export const RenderStatusBadge = (status: string) => {
    const className = TransactionStatusHelper.ClassesMap.get(status) || "default";
    const variant = badgeVariantMap[className] || "default";
    return <AppBadge variant={variant}>{status}</AppBadge>;
};

export const RenderPaymentStatusBadge = (status: PaymentStatus) => {
    const className = TransactionStatusHelper.PaymentStatusClassesMap.get(status) || "default";
    const variant = badgeVariantMap[className] || "default";
    return <AppBadge variant={variant}>{PaymentStatus[status]}</AppBadge>;
};

type AccountBodyProps = {
    onClickAction: (data: any) => void;
    data: any;
};

export function ActionBodyTemplate({ onClickAction, data }: AccountBodyProps) {
    return (
        <React.Fragment>
            <Button icon={<EllipsisVertical size={16} />} size="small" rounded outlined severity="info" aria-label="info" onClick={() => onClickAction(data)} />
        </React.Fragment>
    );
}

export const TransactionSystemFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
    return (
        <InputText
            value={options.value}
            onChange={(e) => options.filterCallback(e.target.value.toUpperCase(), options.index)}
            placeholder={"Search by Payment System"}
            className="p-column-filter"
        />
    );
};
